var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "content" },
    [
      _c("system", { attrs: { leftList: _vm.leftList } }),
      _vm._v(" "),
      _c("div", { staticClass: "pageBox" }, [
        _c(
          "div",
          { staticClass: "breadcrumb" },
          [
            _c(
              "el-breadcrumb",
              { attrs: { separator: "/" } },
              [
                _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
                  _vm._v("首页"),
                ]),
                _vm._v(" "),
                _c("el-breadcrumb-item", [_vm._v("任务管理")]),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "pageTabAdd" },
          [
            _c(
              "el-card",
              { staticClass: "box-card" },
              [
                _c(
                  "div",
                  {
                    staticClass: "clearfix",
                    attrs: { slot: "header" },
                    slot: "header",
                  },
                  [
                    _c("el-page-header", {
                      attrs: {
                        content: _vm.categoryId == "" ? "投诉处理" : "投诉详情",
                      },
                      on: { back: _vm.goBack },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form",
                  {
                    ref: "ruleForm",
                    staticClass: "demo-ruleForm",
                    attrs: {
                      model: _vm.ruleForm,
                      rules: _vm.rules,
                      "label-width": "100px",
                    },
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "投诉编号", prop: "name" } },
                      [
                        _c("el-input", {
                          attrs: { disabled: "", placeholder: "投诉编号" },
                          model: {
                            value: _vm.ruleForm.No,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "No", $$v)
                            },
                            expression: "ruleForm.No",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "任务名称", prop: "name" } },
                      [
                        _c("el-input", {
                          attrs: { disabled: "", placeholder: "任务名称" },
                          model: {
                            value: _vm.ruleForm.name,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "name", $$v)
                            },
                            expression: "ruleForm.name",
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "router-link",
                          {
                            staticClass: "seeJob",
                            attrs: {
                              target: "_blank",
                              to: {
                                path: "/taskDetail",
                                query: { id: _vm.detail.jobId },
                              },
                            },
                          },
                          [_vm._v("查看任务")]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "处理状态", prop: "complainantName" } },
                      [
                        _vm.detail.status == 0
                          ? _c("el-input", {
                              attrs: { disabled: "", placeholder: "投诉中" },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.detail.status == 1
                          ? _c("el-input", {
                              attrs: { disabled: "", placeholder: "已处理" },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.detail.status == 2
                          ? _c("el-input", {
                              attrs: { disabled: "", placeholder: "已撤销" },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "投诉人", prop: "complainantName" } },
                      [
                        _c("el-input", {
                          attrs: { disabled: "", placeholder: "投诉人" },
                          model: {
                            value: _vm.ruleForm.complainantName,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "complainantName", $$v)
                            },
                            expression: "ruleForm.complainantName",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "被投诉人", prop: "respondentName" } },
                      [
                        _c("el-input", {
                          attrs: { disabled: "", placeholder: "被投诉人" },
                          model: {
                            value: _vm.ruleForm.respondentName,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "respondentName", $$v)
                            },
                            expression: "ruleForm.respondentName",
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "router-link",
                          {
                            staticClass: "seeJob",
                            attrs: {
                              target: "_blank",
                              to: {
                                path: "/taskDetail",
                                query: { id: _vm.detail.jobId },
                              },
                            },
                          },
                          [_vm._v("查看考勤")]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: "被投诉人所属", prop: "bodyguardType" },
                      },
                      [
                        _c("el-input", {
                          attrs: { disabled: "", placeholder: "被投诉人所属" },
                          model: {
                            value: _vm.ruleForm.bodyguardType,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "bodyguardType", $$v)
                            },
                            expression: "ruleForm.bodyguardType",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "投诉内容", prop: "complainMemo" } },
                      [
                        _c("el-input", {
                          attrs: { disabled: "", placeholder: "投诉内容" },
                          model: {
                            value: _vm.ruleForm.complainMemo,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "complainMemo", $$v)
                            },
                            expression: "ruleForm.complainMemo",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "投诉时间", prop: "submitAt" } },
                      [
                        _c("el-input", {
                          attrs: { disabled: "", placeholder: "投诉时间" },
                          model: {
                            value: _vm.ruleForm.submitAt,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "submitAt", $$v)
                            },
                            expression: "ruleForm.submitAt",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.isDetail
                      ? _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "保安金额",
                              prop: "bodyguardMoney",
                            },
                          },
                          [
                            _c("el-input", {
                              attrs: { disabled: "", placeholder: "保安金额" },
                              model: {
                                value: _vm.detail.bodyguardMoney,
                                callback: function ($$v) {
                                  _vm.$set(_vm.detail, "bodyguardMoney", $$v)
                                },
                                expression: "detail.bodyguardMoney",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isDetail
                      ? _c(
                          "el-form-item",
                          { attrs: { label: "赔偿金额" } },
                          [
                            _c("el-input", {
                              attrs: { disabled: "", placeholder: "赔偿金额" },
                              model: {
                                value: _vm.detail.amendsMoney,
                                callback: function ($$v) {
                                  _vm.$set(_vm.detail, "amendsMoney", $$v)
                                },
                                expression: "detail.amendsMoney",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isDetail && _vm.detail.userCompensateMoney != 0
                      ? _c(
                          "el-form-item",
                          { attrs: { label: "用户补偿金额" } },
                          [
                            _c("el-input", {
                              attrs: {
                                disabled: "",
                                placeholder: "用户补偿金额",
                              },
                              model: {
                                value: _vm.detail.userCompensateMoney,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.detail,
                                    "userCompensateMoney",
                                    $$v
                                  )
                                },
                                expression: "detail.userCompensateMoney",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isDetail
                      ? _c(
                          "el-form-item",
                          { attrs: { label: "责任人" } },
                          [
                            _c("el-input", {
                              attrs: { disabled: "", placeholder: "责任人" },
                              model: {
                                value: _vm.detail.dutyName,
                                callback: function ($$v) {
                                  _vm.$set(_vm.detail, "dutyName", $$v)
                                },
                                expression: "detail.dutyName",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isDetail
                      ? _c(
                          "el-form-item",
                          { attrs: { label: "处理备注" } },
                          [
                            _c("el-input", {
                              attrs: { disabled: "", placeholder: "处理备注" },
                              model: {
                                value: _vm.detail.memo,
                                callback: function ($$v) {
                                  _vm.$set(_vm.detail, "memo", $$v)
                                },
                                expression: "detail.memo",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.isDetail
                      ? _c(
                          "el-form-item",
                          {
                            staticStyle: {
                              display: "flex",
                              "align-items": "center",
                            },
                            attrs: { label: "责任人", prop: "dutyId" },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  placeholder: "请选择",
                                  disabled: _vm.isDetail,
                                },
                                on: { change: _vm.selectChange },
                                model: {
                                  value: _vm.ruleForm.dutyId,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.ruleForm, "dutyId", $$v)
                                  },
                                  expression: "ruleForm.dutyId",
                                },
                              },
                              _vm._l(_vm.list, function (item, index) {
                                return _c("el-option", {
                                  key: item.id,
                                  attrs: { label: item.name, value: item.id },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.isDetail
                      ? _c(
                          "el-form-item",
                          { attrs: { label: "赔偿金额", prop: "amendsMoney" } },
                          [
                            _c("el-input", {
                              attrs: {
                                disabled: _vm.isDetail,
                                placeholder: "请输入赔偿金额",
                              },
                              model: {
                                value: _vm.ruleForm.amendsMoney,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ruleForm, "amendsMoney", $$v)
                                },
                                expression: "ruleForm.amendsMoney",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.ruleForm.dutyType == 2 && !_vm.isDetail
                      ? _c(
                          "el-form-item",
                          { attrs: { label: "替换", prop: "radio" } },
                          [
                            [
                              _c(
                                "el-radio-group",
                                {
                                  attrs: { disabled: _vm.isDetail },
                                  on: { input: _vm.select },
                                  model: {
                                    value: _vm.ruleForm.radio,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.ruleForm, "radio", $$v)
                                    },
                                    expression: "ruleForm.radio",
                                  },
                                },
                                [
                                  _c(
                                    "el-radio",
                                    {
                                      attrs: { label: "0" },
                                      model: {
                                        value: _vm.ruleForm.radio,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.ruleForm, "radio", $$v)
                                        },
                                        expression: "ruleForm.radio",
                                      },
                                    },
                                    [_vm._v("无需退换")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-radio",
                                    {
                                      attrs: { label: "1" },
                                      model: {
                                        value: _vm.ruleForm.radio,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.ruleForm, "radio", $$v)
                                        },
                                        expression: "ruleForm.radio",
                                      },
                                    },
                                    [_vm._v("需退换")]
                                  ),
                                ],
                                1
                              ),
                            ],
                          ],
                          2
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.isDetail
                      ? _c(
                          "el-form-item",
                          { attrs: { label: "处理备注", prop: "memo" } },
                          [
                            _c("el-input", {
                              attrs: {
                                type: "textarea",
                                rows: 2,
                                disabled: _vm.isDetail,
                                placeholder: "请输入处理备注",
                              },
                              model: {
                                value: _vm.ruleForm.memo,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ruleForm, "memo", $$v)
                                },
                                expression: "ruleForm.memo",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.ruleForm.dutyType == 1
                      ? _c(
                          "el-form-item",
                          { attrs: { label: "保安费用" } },
                          [
                            _c("el-input", {
                              attrs: {
                                disabled: _vm.isDetail,
                                placeholder: "请输入保安费用",
                              },
                              model: {
                                value: _vm.ruleForm.money,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ruleForm, "money", $$v)
                                },
                                expression: "ruleForm.money",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.ruleForm.dutyType != 1
                      ? _c(
                          "el-form-item",
                          { attrs: { label: "用户补偿", prop: "money1" } },
                          [
                            _c("el-input", {
                              attrs: {
                                disabled: _vm.isDetail,
                                placeholder: "请输入用户补偿",
                              },
                              model: {
                                value: _vm.ruleForm.money1,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ruleForm, "money1", $$v)
                                },
                                expression: "ruleForm.money1",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.ruleForm.radio == 1 && _vm.ruleForm.dutyType != 1
                      ? _c(
                          "el-form-item",
                          {
                            staticStyle: {
                              display: "flex",
                              "align-items": "center",
                            },
                            attrs: { label: "替补人员", prop: "edit" },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  placeholder: "请选择",
                                  disabled: _vm.isDetail,
                                },
                                model: {
                                  value: _vm.ruleForm.edit,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.ruleForm, "edit", $$v)
                                  },
                                  expression: "ruleForm.edit",
                                },
                              },
                              _vm._l(_vm.list1, function (item, index) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: {
                                    label: item.cardName || item.companyName,
                                    value: item.id,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.ruleForm.radio == 1 && _vm.ruleForm.dutyType != 1
                      ? _c(
                          "el-form-item",
                          { attrs: { label: "变更备注", prop: "editMemo" } },
                          [
                            _c("el-input", {
                              attrs: {
                                type: "textarea",
                                rows: 2,
                                disabled: _vm.isDetail,
                                placeholder: "请输入变更备注",
                              },
                              model: {
                                value: _vm.ruleForm.editMemo,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ruleForm, "editMemo", $$v)
                                },
                                expression: "ruleForm.editMemo",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.isDetail
                      ? _c(
                          "el-form-item",
                          [
                            _c(
                              "el-button",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.close()
                                  },
                                },
                              },
                              [_vm._v("取消")]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-button",
                              {
                                staticClass: "btn",
                                staticStyle: { "margin-right": "auto" },
                                on: {
                                  click: function ($event) {
                                    return _vm.submitForm("ruleForm")
                                  },
                                },
                              },
                              [_vm._v("保存")]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }